export default class QuickSearchCounter {

    constructor(element) {
        this.$element = $(element);
    }

    init() {
        const formElements = this.$element.find('input[type=checkbox],input[type=hidden],input[type=text]:not(#zipcode),select');
        const self = this;

        // self.executeAjaxCall(null);

        formElements.off('change').on('change', function () {
            self.executeAjaxCall($(this));
        });
    }

    executeAjaxCall(target) {
        const options = {
            method: 'POST',
            data: JSON.stringify(this.getFormValues(target)),
            processData: false,
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'cache-control': 'no-cache'}
        };

        $.ajax('/rest/count', options).done(function (data) {
            $('#quick-search-submit-button').text(data.formattedCount + ' Risultati');
        }).fail(function (error) {
            $('#quick-search-submit-button').text('0 Risultati');
        });
    }

    getFormValues(target) {
        const manuallyManagedAttributes = ['maker', 'model', 'attr_m_trim', 'attr_m_channel_i', 'radius', 'area_id'];

        let params = this.$element.serializeArray();
        let formValues = {'params': {}};

        this.manageTrim(params, formValues);
        this.manageChannels(params, formValues);
        this.manageAreaId(target, formValues);
        this.manageOtherParams(params, formValues, manuallyManagedAttributes);

        return formValues;
    }

    manageTrim(params, formValues) {
        const maker = params.filter(item => {
            return item.name === 'maker';
        });
        const model = params.filter(item => {
            return item.name === 'model';
        });

        if (typeof maker[0] !== 'undefined' && maker[0].value !== '') {
            formValues['params']['attr_m_trim'] = [maker[0].value];
            // only change the trim if value contained in the model is belonging to the selected make
            if (typeof model[0] !== 'undefined' && model[0].value !== '' && model[0].value.startsWith(maker[0].value)) {
                formValues['params']['attr_m_trim'] = [model[0].value];
            }
        } else {
            delete formValues['params']['attr_m_trim'];
        }
    }

    manageChannels(params, formValues) {
        let channels = params.filter(channel => {
            return channel.name === 'attr_m_channel_i';
        }).map(channel => {
            return channel.value;
        });
        formValues['params']['attr_m_channel_i'] = channels;
        if (channels.length === 0) {
            delete formValues['params']['attr_m_channel_i'];
        }
        if (channels.indexOf('1') !== -1) {
            formValues['params']['attr_m_channel_used_i'] = ['1', '2', '3'];
        }
    }

    manageAreaId(target, formValues) {
        const location = $('#zipcode').val();
        if (/\d+/.test(location)) { // is a zipcode search
            delete formValues['params']['area_id'];
            formValues['params']['zipcode'] = [`${$('[data-location-element]').val()}`];
            if (target.attr('id') !== 'radius') {
                if ($('#radius').val() !== null) {
                    formValues['params']['radius'] = [`${$('#radius').val()}`];
                } else {
                    formValues['params']['radius'] = [`${$('#radius').data('defaultValue')}`];
                }
            } else {
                formValues['params']['radius'] = [`${$('#radius').val()}`];
            }
        } else {
            formValues['params']['area_id'] = [`${$('[data-location-element]').val()}`];
        }
    }

    manageOtherParams(params, formValues, manuallyManagedAttributes) {
        params.filter(item => {
            return manuallyManagedAttributes.indexOf(item.name) === -1;
        }).filter(item => {
            return item.value !== '';
        }).map(param => {
            formValues['params'][param.name] = [param.value];
        });
    }

}
